import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Scale } from "lucide-react";
import { Link } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";
import { useLanguage } from "@/hooks/useLanguage";

const MentionsLegales = () => {
  const { t, locale } = useLanguage("legal");
  useSEO({ title: t("mentions.title"), canonical: "/mentions-legales", locale });
  return (
    <div className="min-h-screen" dir={locale === "ar" ? "rtl" : "ltr"}>
      <Navbar />
      <main className="container max-w-3xl py-10 space-y-10">
        <div className="space-y-3">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
              <Scale className="h-5 w-5 text-primary" />
            </div>
            <h1 className="font-display text-3xl font-bold">{t("mentions.title")}</h1>
          </div>
          <p className="text-sm text-muted-foreground">{t("mentions.last_updated")}</p>
          <p className="text-muted-foreground leading-relaxed">{t("mentions.intro")}</p>
        </div>

        <section className="space-y-3">
          <h2 className="font-display text-xl font-semibold">{t("mentions.s1_title")}</h2>
          <div className="grid grid-cols-2 gap-2 text-sm">
            <span className="font-medium">{t("mentions.s1_platform")}</span><span>Hirafi</span>
            <span className="font-medium">{t("mentions.s1_url")}</span><span>hirafidz.com</span>
            <span className="font-medium">{t("mentions.s1_email")}</span><span>contact@hirafidz.com</span>
            <span className="font-medium">{t("mentions.s1_status")}</span><span>{t("mentions.s1_status_val")}</span>
            <span className="font-medium">{t("mentions.s1_siege")}</span><span>{t("mentions.s1_siege_val")}</span>
          </div>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-xl font-semibold">{t("mentions.s2_title")}</h2>
          <p className="text-muted-foreground">{t("mentions.s2_body")}</p>
          <p className="text-sm">{t("mentions.s2_contact")} <a href="mailto:contact@hirafidz.com" className="text-primary hover:underline">contact@hirafidz.com</a></p>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-xl font-semibold">{t("mentions.s3_title")}</h2>
          <p className="text-muted-foreground">{t("mentions.s3_intro")}</p>
          <div className="space-y-3">
            <div>
              <p className="font-medium text-sm">{t("mentions.s3_frontend_title")}</p>
              <p className="text-muted-foreground text-sm">{t("mentions.s3_vercel_addr")}</p>
              <p className="text-muted-foreground text-sm">{t("mentions.s3_site")} : <a href="https://vercel.com" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">vercel.com</a></p>
            </div>
            <div>
              <p className="font-medium text-sm">{t("mentions.s3_backend_title")}</p>
              <p className="text-muted-foreground text-sm">Supabase — {t("mentions.s3_supabase_addr")}</p>
              <p className="text-muted-foreground text-sm">{t("mentions.s3_site")} : <a href="https://supabase.com" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">supabase.com</a></p>
            </div>
          </div>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-xl font-semibold">{t("mentions.s4_title")}</h2>
          <p className="text-muted-foreground leading-relaxed">{t("mentions.s4_body1")}</p>
          <p className="text-muted-foreground leading-relaxed">{t("mentions.s4_body2")}</p>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-xl font-semibold">{t("mentions.s5_title")}</h2>
          <p className="text-muted-foreground leading-relaxed">{t("mentions.s5_body1")}</p>
          <p className="text-muted-foreground leading-relaxed">{t("mentions.s5_body2")}</p>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-xl font-semibold">{t("mentions.s6_title")}</h2>
          <p className="text-muted-foreground leading-relaxed">{t("mentions.s6_body")}</p>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-xl font-semibold">{t("mentions.s7_title")}</h2>
          <p className="text-muted-foreground leading-relaxed">{t("mentions.s7_body")}</p>
        </section>

        <section className="space-y-3">
          <h2 className="font-display text-xl font-semibold">{t("mentions.s8_title")}</h2>
          <p className="text-muted-foreground">{t("mentions.s8_body")}</p>
          <a href="mailto:contact@hirafidz.com" className="text-primary hover:underline">contact@hirafidz.com</a>
        </section>

        <div className="border-t pt-6 flex flex-wrap gap-4 text-sm text-muted-foreground">
          <Link to="/cgu" className="hover:text-primary hover:underline">{t("mentions.link_cgu")}</Link>
          <Link to="/politique-confidentialite" className="hover:text-primary hover:underline">{t("mentions.link_confidentialite")}</Link>
          <Link to="/a-propos" className="hover:text-primary hover:underline">{t("mentions.link_apropos")}</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MentionsLegales;
